import axios from "axios";

const instance = axios.create({
  baseURL: "https://registration.portal.oshsu.kg/api",
  withCredentials: true,
  headers: {
    accept: "application/json",
  },
});


export default instance;
